import React, { useState } from "react";
import TopHeader from "./nav_top.js";
import OptionsTradeTable from "./_54_today_trade_options.js";
import OptionsMonthlyPLChart from "./_65_options_chart.js";

import "./styles.css";

const MODULE_NAME = "pg_options";

const OptionsPage = () => {
  // Read userId from sessionStorage, fallback to 1 if not set or invalid
  const storedId = sessionStorage.getItem("user_id");
  const userId = storedId && !isNaN(Number(storedId)) ? Number(storedId) : 1;

  const activeDate = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  const initialScreen = "pg_options";

  const [screen, setScreen] = useState(initialScreen);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <>
      <TopHeader 
        userId={userId} 
        screen={screen} 
        refreshKey={refreshKey}
        onNavigate={setScreen}
          />
          <OptionsMonthlyPLChart userId={userId} activeDate={activeDate} screen={screen} refreshKey={refreshKey} />
      <div style={{ paddingBottom: 50 }} />
      <OptionsTradeTable userId={userId} activeDate={activeDate} screen={screen} refreshKey={refreshKey} />
    </>
  );
};

export default OptionsPage;